import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const SoftwareLicenseDirectDepositModalTrigger = ({modalId, iconCssClass}) => {
    const softwareLicenseDirectDepositModal = useSelector((state) => state.softwareLicenseDirectDepositModal);
    const userDemoedLicenseProducts = useSelector((state) => state.userDemoedLicenseProducts);
    const userOwnedFullLicenseProducts = useSelector((state) => state.userOwnedFullLicenseProducts);

    const showModal = () => {
        document.querySelector(modalId).showModal();
        stopBodyScroll();
    }

    return (
        <Fragment>
            {(softwareLicenseDirectDepositModal.productArticleNumber && softwareLicenseDirectDepositModal.licenseProductArticleNumber) &&
                <Fragment>
                    {softwareLicenseDirectDepositModal.type === 0 ? (
                        <Fragment>
                            {/* SoftwareLicenseDirectDepositModalType.Demo */}
                            {(userOwnedFullLicenseProducts && userOwnedFullLicenseProducts.indexOf(softwareLicenseDirectDepositModal.licenseProductArticleNumber) > -1) ? (
                                <button className="button button__outline" disabled>
                                    <i className="icon-check"></i>
                                    <span>{translate('js.productpage.demobuttontext.owned')}</span>
                                </button>
                            ) : (
                                <Fragment>
                                    {(userDemoedLicenseProducts && userDemoedLicenseProducts.indexOf(softwareLicenseDirectDepositModal.licenseProductArticleNumber) > -1) ? (
                                        <button className="button button__outline" disabled>
                                            <i className="icon-check"></i>
                                            <span>{translate('js.productpage.demobuttontext.demoed')}</span>
                                        </button>
                                    ) : (
                                        <button onClick={() => showModal()} className="button button__outline">
                                            {iconCssClass &&
                                                <i className={iconCssClass}></i>
                                            }
                                            <span>{translate('js.productpage.demobuttontext')}</span>
                                        </button>
                                    )}
                                </Fragment>
                            )}
                        </Fragment>
                    ) : (
                        <Fragment>
                            {/*SoftwareLicenseDirectDepositModalType.Free*/}
                            {(userOwnedFullLicenseProducts && userOwnedFullLicenseProducts.indexOf(softwareLicenseDirectDepositModal.licenseProductArticleNumber) > -1) ? (
                                <button className="button button__outline" disabled>
                                    <i className="icon-check"></i>
                                    <span>{translate('js.productpage.freebuttontext.owned')}</span>
                                </button>
                            ) : (
                                <button onClick={() => showModal()} className="button">
                                    {iconCssClass &&
                                        <i className={iconCssClass}></i>
                                    }
                                    <span>{translate('js.productpage.freebuttontext')}</span>
                                </button>
                            )}
                        </Fragment>
                    )}
                </Fragment>
            }
        </Fragment>
    );
};

export default SoftwareLicenseDirectDepositModalTrigger;
